import React from 'react';
import WhatWeDo from './WhatWeDo';
import SectionFooter from './SectionFooter';
import './SectionWhatWeDo.css';

class SectionWhatWeDo extends React.Component {
  render() {
    const {sectionHeader, sectionFooter, items} = this.props.whatWeDoData;
    return (
      <section id='what-we-do'>
        <div className='row section-header'>
          <h2 className='text-center'>Training Tailored to meet your NEEDS</h2>
          <p className='long-copy'>{`No canned training! All curriculum and exercises are developed and "KEYed" to your immediate organizational needs.
            Seminars are delivered by experienced facilitators in a high-energy interactive format.
            Popular topics requested include but are not limited to:`}</p>
        </div>
        <WhatWeDo items={items}/>
        <SectionFooter footerText={sectionFooter}/>
      </section>
    );
  }
}

SectionWhatWeDo.propTypes = {
  whatWeDoData: React.PropTypes.object.isRequired
}

export default SectionWhatWeDo;



// WEBPACK FOOTER //
// ./src/components/SectionWhatWeDo.js